import PropTypes from 'prop-types';

export const ClpPropTypes = {
  totalProductsCount: PropTypes.number,
  paginatedProducts: PropTypes.arrayOf(),
  onQuickViewOpenClick: PropTypes.func,
  onAddItemToFavorites: PropTypes.func,
  onSetLastDeletedItemIdAction: PropTypes.func,
  loadSeoDetails: PropTypes.func,
  onFavtLoad: PropTypes.func,
  wishListData: PropTypes.shape({}),
  isShortImage: PropTypes.bool,
  isABTestForStickyFilter: PropTypes.bool,
  processedBreadCrumbs: PropTypes.arrayOf(),
  seoTitle: PropTypes.string,
  seoMetaDesc: PropTypes.string,
  canonicalUrl: PropTypes.string,
  router: PropTypes.shape({
    query: PropTypes.shape({
      cid: PropTypes.shape({}),
    }),
    asPath: PropTypes.string,
  }),
  isHorizontalPlpEnabled: PropTypes.bool,
  getCategoryBasedProductsActn: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  getPaginatedProductsActn: PropTypes.func,
  fetchInitialProductsWithFacets: PropTypes.func,
  toggleTrackerAction: PropTypes.func,
  trackClickBundles: PropTypes.func,
  isBundleTrackerEnabled: PropTypes.bool,
  isTrackerOpen: PropTypes.bool,
  bundleProducts: PropTypes.arrayOf(),
  promotionsData: PropTypes.shape({}),
  isInitialCall: PropTypes.bool,
  isSyteEnabled: PropTypes.bool,
  recordsPerPage: PropTypes.number,
  topPromosContent: PropTypes.arrayOf(),
  isAlternatePlpEnabled: PropTypes.bool,
  isPLPCategoryPillsEnabled: PropTypes.bool,
  isPaginatedAlternatePlpEnabled: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
  trackPageLoadSearchRedirect: PropTypes.func,
  getHomePageLayout: PropTypes.func.isRequired,
  layouts: PropTypes.shape({}),
  isProductLoadingFlag: PropTypes.bool,
  setIsProductLoadingActn: PropTypes.func,
  appliedFilterIdsAndLength: PropTypes.shape({}),
};

export const ClpDefaultProps = {
  totalProductsCount: 0,
  paginatedProducts: [],
  onQuickViewOpenClick: () => {},
  onAddItemToFavorites: () => {},
  onSetLastDeletedItemIdAction: () => {},
  loadSeoDetails: () => {},
  onFavtLoad: () => {},
  wishListData: {},
  isShortImage: false,
  isABTestForStickyFilter: false,
  processedBreadCrumbs: [],
  seoTitle: '',
  seoMetaDesc: '',
  canonicalUrl: '',
  router: { query: { cid: '' } },
  isHorizontalPlpEnabled: false,
  getCategoryBasedProductsActn: () => {},
  isLoggedIn: false,
  getPaginatedProductsActn: () => {},
  fetchInitialProductsWithFacets: () => {},
  toggleTrackerAction: () => {},
  trackClickBundles: () => {},
  isBundleTrackerEnabled: false,
  isTrackerOpen: false,
  bundleProducts: [],
  promotionsData: {},
  isInitialCall: false,
  isSyteEnabled: false,
  recordsPerPage: 30,
  topPromosContent: [],
  isAlternatePlpEnabled: false,
  isPaginatedAlternatePlpEnabled: false,
  isPLPCategoryPillsEnabled: false,
  isOneClickATCEnabled: false,
  addToBagEcom: () => {},
  trackPageLoadSearchRedirect: () => {},
  getHomePageLayout: () => {},
  layouts: {},
  isProductLoadingFlag: false,
  setIsProductLoadingActn: () => {},
  appliedFilterIdsAndLength: {},
};
